module.exports = __webpack_public_path__ + "img/alma-palermo.b0c58268.jpg";